<template>
  	<div class="comment-reaction">
	  	<div class="reaction-emoji">
			<slot name="selectedEmoji" class="selected-emoji">
  				<div class="span-emoji" :class="{ 'opacity' : selected }" v-if="reactions && reactions.length != 0">
	              <img v-if="hasReactions('crying')" :src="require(`@/assets/icon/emoji/crying.svg`)" alt="crying" />
	              <img v-if="hasReactions('laughing')" :src="require(`@/assets/icon/emoji/laughing.svg`)" alt="laughing" />
	              <img v-if="hasReactions('wow')" :src="require(`@/assets/icon/emoji/wow.svg`)" alt="wow" />
	              <img v-if="hasReactions('love')" :src="require(`@/assets/icon/emoji/love.svg`)" alt="love" />
  				</div>
		        <div v-else>
		            Like 
		        </div>
		        <span style="margin-left: 4px">({{ reactions.length }})</span>

	        </slot>        
	  	    <div class="emoji-container">
	  	        <button class="emoji love" @click="pushReaction('love')" :class="{selectedEmoji:selected == 'love'}">
	  	            <img src="../../../assets/icon/emoji/love.svg" alt="love-icon" />
	  	            <span>Love</span>
	  	        </button>
	  	        <button class="emoji laughing" @click="pushReaction('laughing')" :class="{selectedEmoji:selected == 'laughing'}">
	  	            <img src="../../../assets/icon/emoji/laughing.svg" alt="laughing-icon" />
	  	            <span>Laugh</span>
	  	        </button>
	  	        <button class="emoji crying" @click="pushReaction('crying')" :class="{selectedEmoji:selected == 'crying'}">
	  	            <img src="../../../assets/icon/emoji/crying.svg" alt="crying-icon" />
	  	            <span>Cry</span>
	  	        </button>
	  	        <button class="emoji wow" @click="pushReaction('wow')" :class="{selectedEmoji:selected == 'wow'}">
	  	            <img src="../../../assets/icon/emoji/wow.svg" alt="wow-icon" />
	  	            <span>wow</span>
	  	        </button>
	  	    </div>
	  	</div>
  	</div>
</template>


<script>


export default {
  name: "comment-reaction",

  props: ['postReaction'],

	data(){
		return{
	      isHovering: false,
	      reactions: this.postReaction,
	      allReactions:[],
	      selected: ''
		}
	},

	methods:{

	    /*
	    * Push Post Reactions
	    */
	    hasReactions(data) {
	        return this.postReaction.some(function(elem) {
	          return elem.reaction==data;
	        })
	    },

	    /*
	    * Push Post Reactions
	    */
	    pushReaction(data, authId=4) {
	      this.selected = data;
	      var isFound = false;
	      for (var i = 0; i < this.postReaction.length; i++) {
	        if(this.postReaction[i].userId===authId) {
	          isFound=true;
	          if(this.postReaction[i].reaction===data) {
	            // pop from array
	            this.postReaction.pop({userId:authId, reaction:data});
	            this.selected = '';
	            break;
	          } else {
	            // change value
	            this.postReaction[i].reaction=data;
	            break;
	          }
	        }
	      }

	      // if not found
	      if(isFound==false) {
	        this.postReaction.push({userId:authId, reaction:data});
	        localStorage.setItem('myReactions', JSON.stringify({userId:authId, reaction:data}));
	      }
	      setTimeout(()=>{
	         this.isHovering=false;
	      },300);
	    }

	}
	
}

</script>